import Configs from "../config";
import { ILabel } from "../types/LabelTypes";
import { DefaultResponse } from "../types/UtilTypes";
import { localStorageGetItem } from "../utils/LocalStorage";

interface ICreateLabel {
  name: string;
  color: string;
  labelIndex: number;
}

export interface ICreateLabelResponse {
  _id: string;
  name: string;
  color: string;
  userUid: string;
}

interface IReadLabel extends ILabel {
  _id: string;
}

interface IUpdateLabel {
  count: number;
}

interface IDeleteLabel {
  deleted: number;
}

export const createLabel = async ({
  name,
  color,
  labelIndex,
}: ICreateLabel): Promise<ICreateLabelResponse> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/label`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      name,
      color,
      userUid,
      labelIndex,
    }),
  });

  const labels: DefaultResponse<ICreateLabelResponse> = await response.json();
  if (labels.status === "ok") {
    return labels.data as ICreateLabelResponse;
  }

  throw new Error(labels.code);
};

export const readLabel = async (id: string): Promise<IReadLabel> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/label/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const labels: DefaultResponse<IReadLabel> = await response.json();
  if (labels.status === "ok") {
    return labels.data as IReadLabel;
  }

  throw new Error(labels.code);
};

export const readAllLabels = async (): Promise<IReadLabel[]> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/label`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const labels: DefaultResponse<ILabel[]> = await response.json();
  if (labels.status === "ok") {
    return labels.data as IReadLabel[];
  }

  throw new Error(labels.code);
};

export const updateLabel = async (
  labelId: string,
  { color, name }: ILabel
): Promise<IUpdateLabel> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/label/${labelId}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      color,
      name,
      userUid,
    }),
  });

  const labels: DefaultResponse<IUpdateLabel> = await response.json();
  if (labels.status === "ok") {
    return labels.data as IUpdateLabel;
  }

  throw new Error(labels.code);
};

export const deleteLabel = async (labelId: string): Promise<IDeleteLabel> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/label/${labelId}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
    },
  });

  const labels: DefaultResponse<IDeleteLabel> = await response.json();
  if (labels.status === "ok") {
    return labels.data as IDeleteLabel;
  }

  throw new Error(labels.code);
};

export const updateAllLabels = async (
  labels: ILabel[]
): Promise<IUpdateLabel> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/label/update-all`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      labels,
    }),
  });

  const result: DefaultResponse<IUpdateLabel> = await response.json();
  if (result.status === "ok") {
    return result.data as IUpdateLabel;
  }

  throw new Error(result.code);
};
